"use client"
import { MenuItem } from "@mantine/core"
import { IconLogout } from "@tabler/icons-react"
import { useLogout } from "@/hooks/useLogout"

export function MenuItemLogOutButton() {
  const { performLogout } = useLogout()

  return (
    <MenuItem color="red" leftSection={<IconLogout size={16} data-testid="menu-item-log-out-btn" />} onClick={performLogout}>
      Log Out
    </MenuItem>
  )
}
